export default __webpack_public_path__ + "676f296bf21ee566e9969b8a135c8647.png";